'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _define = require('./define');

var _define2 = _interopRequireDefault(_define);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pre = function pre(prop, obj) {
  return obj[prop];
}; /**
    * Get property of an object
    *
    * @module getProp
    * @func
    * @since 1.15.0
    * @param {string|number} prop
    * @param {Object} obj
    * @return {function|*}
    * @example
    *
    *     getProp('a', { a: 1 }); //=> 1
    *     getProp('b')({ b: 2 }); //=> 2
    */

var getProp = (0, _define2.default)(pre);

exports.default = getProp;